<template>
  <div class="create-thing-container">
    <w-nav-bar nav_title="我的待办" @mobileLeftBtn="pageBack"></w-nav-bar>
    <div class="create-form-content">
      <div class="form-item">
        <p class="title-content flex-start">
          <span class="title">校招公司</span>
          <span class="title-important">*</span>
        </p>
        <input class="form-text" type="text" placeholder="添加校招公司（必填）" maxlength="20" @input="valueChange($event)" v-model="companyName" :disabled="backUpData.id || createRecruitFromCampus">
        <div class="search-result-content" v-if="companyListBySearch.length">
          <cube-scroll :data="companyListBySearch">
            <div class="company-item flex-between" v-for="(item, index) in companyListBySearch" :key="index" @click="handleCompanyItemClick(item)">
              <span v-html="item.nick_name_highlight || item.highlight"></span>
              <span v-if="item.is_apply" class="is-apply flex-center">已添加</span>
            </div>
          </cube-scroll>
        </div>
      </div>
      <div class="form-item" v-if="(thingsData.company_token && campusPickerData.length) || ((backUpData.id || createRecruitFromCampus) && thingsData.comp_recruit_info_token)">
        <p class="title-content flex-start">
          <span class="title">校招批次</span>
          <span class="title-important">*</span>
        </p>
        <div class="form-text flex-start" :class="{'form-text-diabled': backUpData.id || createRecruitFromCampus}" @click="handleCampusPicker">
          <span>{{compRecruitInfoName}}</span>
          <i class="iconfont iconRectangle-copy"></i>
        </div>
      </div>
      <transition name="w-fade">
        <div v-show="!companyListBySearch.length">
          <div class="form-item">
            <p class="title-content flex-start">
              <span class="title">事项</span>
              <span class="title-important">*</span>
            </p>
            <div class="form-text flex-start" :class="{'empty-value': !thingsData.step_type}" @click="handleStepPicker">
              <span>{{thingsData.step_type || '添加事项（必填）'}}</span>
              <i class="iconfont iconRectangle-copy"></i>
            </div>
          </div>
          <div class="form-item">
            <p class="title-content flex-start">
              <span class="title">时间</span>
              <span class="title-important">*</span>
            </p>
            <div class="flex-center">
              <div class="date-input flex-start" :class="{'empty-value': !executeDate}" @click="handleDatePicker">{{executeDate || '添加时间（必填）'}}</div>
              <div class="divider"></div>
              <div class="time-input flex-start" @click="handleTimePicker">{{executeTime}}</div>
            </div>
          </div>
          <div class="form-item">
            <p class="title-content flex-start">
              <span class="title">地点</span>
            </p>
            <input class="form-text" type="text" v-model="thingsData.address" placeholder="添加地点（选填）" maxlength="20">
          </div>
          <div class="form-item">
            <p class="title-content flex-start">
              <span class="title">备注</span>
            </p>
            <w-auto-textarea v-model="thingsData.remark" :placeholder="'添加备注（选填）'" :minRow="3" :maxRow="6"
              :fontMaxSize="50" />
          </div>
        </div>
      </transition>
    </div>
    <transition name="w-fade">
      <div class="create-btn-content flex-center" v-show="!companyListBySearch.length">
        <button class="delete-btn white-button flex-center" v-if="backUpData.id" @click="deleteThings">
          <i class="iconfont iconshanchujianli"></i>
          <span>删除</span>
        </button>
        <button class="create-btn theme-button flex-center" :class="{'btn-disabled': saveDisabled}" @click="submitFormData">保存</button>
      </div>
    </transition>
  </div>
</template>

<script>
import WNavBar from '../../../../components/global/w-navbar'
import WAutoTextarea from '../../../../components/global/w-auto-textarea'
import { componentsMixin } from '../../../../assets/js/mixin/components'
import { mapState, mapMutations } from 'vuex'
const moment = require('moment')
const StepPickerData = [
  {
    text: '网申',
    value: '网申'
  },
  {
    text: '宣讲会',
    value: '宣讲会'
  },
  {
    text: '笔试',
    value: '笔试'
  },
  {
    text: '初面',
    value: '初面'
  },
  {
    text: '二面',
    value: '二面'
  },
  {
    text: '终面',
    value: '终面'
  },
  {
    text: '谈offer',
    value: '谈offer'
  },
]
const emptyFormConfig = [
  {
    field: 'company_token',
    message: '请添加校招公司'
  },
  {
    field: 'step_type',
    message: '请选择事项'
  },
  {
    field: 'executeDate',
    message: '请添加日期'
  },
  {
    field: 'executeTime',
    message: '请添加时间'
  }
]
export default {
  mixins: [componentsMixin],
  data () {
    return {
      executeDate: '',
      backExecuteDate: '',
      executeTime: '',
      backExecteTime: '',
      campusPickerData: [],
      backUpData: {},
      compRecruitInfoName: '',
      companyListBySearch: [],
      companyName: '',
      createRecruitFromCampus: false,
      isCreating: false,
      thingsData: {
        remark: '',
        execute_at: '',
        step_type: '',
        address: '',
        comp_recruit_info_token: '',
        company_token: ''
      },
    }
  },
  mounted () {
    this.initPageData()
  },
  components: {
    WNavBar,
    WAutoTextarea
  },
  watch: {},
  computed: {
    ...mapState('campusOffers', ['weekThingsData']),
    saveDisabled() {
      return !this.thingsData.company_token || !this.thingsData.step_type || !this.executeDate || !this.executeTime
    }
  },
  methods: {
    ...mapMutations('campusOffers', {
      setAllWeekThings: 'SET_ALL_WEEK_THINGS'
    }),
    // 删除待办
    deleteThings() {
      this.$createDialog({
        title: '删除提示',
        content: '确认删除该项待办吗？',
        type: 'confirm',
        onConfirm: () => {
          this.$api.campusOffers.deleteRecruitment(this.backUpData.id).then(res => {
            if (res.code === 1000) {
              this.$router.back()
            } else {
              this.showToast(res.message)
            }
          })
        }
      }).show()
    },
    // 页面初始化数据
    initPageData() {
      document.title = '校招规划局'
      let { id } = this.$route.query
      let { comp_name, comp_recruit_info_token, company_token, company_name } = this.$route.params
      console.log(company_token, company_name)
      if (id) {
        this.$api.campusOffers.getCampusRecruitment(id).then(res => {
          if (res.code === 1000) {
            this.backUpData = JSON.parse(JSON.stringify(res.data))
            this.thingsData = JSON.parse(JSON.stringify(res.data))
            this.companyName = res.data.company_name
            this.compRecruitInfoName = res.data.comp_name
            this.executeDate = this.backExecuteDate = moment(res.data.execute_at).format('YYYY-MM-DD')
            this.executeTime = this.backExecteTime = moment(res.data.execute_at).format('HH:mm')
          }
        }).catch(e => console.log(e))
      } else if (company_token) {
        this.createRecruitFromCampus = true
        this.thingsData = { ...this.thingsData, company_token, comp_recruit_info_token }
        this.companyName = company_name
        this.compRecruitInfoName = comp_name
      }
    },
    // 页面返回事件
    pageBack() {
      let { id } = this.$route.query
      if (id) {
        if (this.verifyEditChange() || this.executeDate !== this.backExecuteDate || this.executeTime !== this.backExecteTime) {
          this.createBackDialog()
        } else {
          this.$router.back()
        }
      } else {
        if (this.executeDate || this.executeTime || this.verifyCreateEmpty()) {
          this.createBackDialog()
        } else {
          this.$router.back()
        }
      }
    },
    // 创建返回提示步骤
    createBackDialog() {
      this.$createDialog({
        title: '修改提示',
        type: 'confirm',
        content: '退出编辑将无法保存修改内容',
        onConfirm: () => {
          this.$router.back()
        },
      }).show()
    },
    // 创建步骤的时候返回校验是否有值
    verifyCreateEmpty() {
      for (let key in this.thingsData) {
        if (this.thingsData[key]) return true
      }
    },
    // 编辑时点击返回校验是否有修改
    verifyEditChange() {
      const dataKeys = Object.keys(this.backUpData)
      for (let i = 0; i < dataKeys.length; i++) {
        if (this.thingsData[dataKeys[i]] !== this.backUpData[dataKeys[i]]) return true
      }
    },
    // 点击保存
    async submitFormData() {
      if (this.isCreating) {
        return
      }
      try {
        if (this.saveDisabled) {
          let message = this.emptyValueNotice()
          this.showToast(message, 1500)
        } else {
          let res = {}
          this.thingsData.execute_at = `${this.executeDate} ${this.executeTime}`
          this.isCreating = true
          if (this.$route.query.id) {
            res = await this.$api.campusOffers.updateCampusRecruitment(this.$route.query.id, this.thingsData)
          } else {
            res = await this.$api.campusOffers.createCampusRecruitment(this.thingsData)
          }
          if (res.code === 1000) {
            let weekStart = moment(this.executeDate).startOf('weeks').format('YYYY-MM-DD')
            this.setAllWeekThings({ ...this.weekThingsData, [weekStart]: undefined })
            this.isCreating = false
            this.$router.back()
          } else {
            this.isCreating = false
          }
        }    
      } catch (error) {
        this.isCreating = false
        console.log(error)
      }
    },
    // 校招批次的选项
    handleCampusPicker() {
      if (!this.$route.query.id && !this.createRecruitFromCampus) {
        this.$createPicker({
          data: [this.campusPickerData],
          onSelect: val => {
            this.thingsData.comp_recruit_info_token = val.join()
            const campusPickerItem = this.campusPickerData.find(item => item.value === val.join())
            if (campusPickerItem) this.compRecruitInfoName = campusPickerItem.text
          }
        }).show()
      }
    },
    // 点击选择事项
    handleStepPicker() {
      const selectedIndex = StepPickerData.findIndex(item => item.value === this.thingsData.step_type)
      this.$createPicker({
        data: [StepPickerData],
        selectedIndex: [selectedIndex > -1 ? selectedIndex : 0],
        onSelect: val => {
          this.thingsData.step_type = val.join()
        }
      }).show()
    },
    // 点击选择日期
    handleDatePicker() {
      this.$createDatePicker({
        min: new Date(moment('2021-01-01')),
        max: new Date(moment().add(1, 'years')),
        value: new Date(),
        onSelect: date => {
          this.executeDate = moment(date).format('YYYY-MM-DD')
        }
      }).show()
    },
    // 点击选择时间
    handleTimePicker() {
      let timePickerData = []
      let defaultSelectHour = moment().add(1, 'hours').format('HH')
      for (let i = 0; i < 24; i += 0.5) {
        timePickerData.push({
          text: moment().startOf('days').add(i, 'hours').format('HH:mm'),
          value: moment().startOf('days').add(i, 'hours').format('HH:mm')
        })
      }
      const hourIndex = timePickerData.findIndex(item => item.value.slice(0, 2) === defaultSelectHour)
      this.$createPicker({
        data: [timePickerData],
        selectedIndex: [hourIndex],
        onSelect: val => {
          this.executeTime = val.join()
        }
      }).show()
    },
    // 点击补全的品牌或者公司
    handleCompanyItemClick(item) {
      this.companyName = item.nick_name || item.name
      this.thingsData.company_token = item.token
      this.resetCompanyList()
      this.getCampusRecruitments()
    },
    // 重置公司列表
    resetCompanyList() {
      this.companyListBySearch = []
    },
    // 空值提示
    emptyValueNotice() {
      for (let i = 0; i < emptyFormConfig.length; i++) {
        if (!this[emptyFormConfig[i].field] && !this.thingsData[emptyFormConfig[i].field]) {
          return emptyFormConfig[i].message
        }
      }
    },
    // 品牌或者公司的自动补全逻辑
    valueChange(e) {
      this.thingsData.company_token = ''
      this.campusPickerData = []
      this.thingsData.comp_recruit_info_token = ''
      this.compRecruitInfoName = ''
      if (e.target.value) {
        this.debounce(() => {
          this.$api.campusOffers.campusCompanyComplete({
            keyword: e.target.value,
            size: 30
          }).then(res => {
            if (res.code === 1000) {
              this.companyListBySearch = res.data
            }
          }).catch(e => console.log(e))
        }, 300)
      }
    },
    // 获取特定公司的网申
    getCampusRecruitments() {
      this.$api.campusOffers.getCampusRecruitments(this.thingsData.company_token).then(res => {
        if (res.code === 1000) {
          this.campusPickerData = res.data.comp_recruit_infos.map(item => {
            return {
              text: item.company_name,
              value: item.token
            }
          })
          if (this.campusPickerData.length) {
            this.thingsData.comp_recruit_info_token = this.campusPickerData[0].value
            this.compRecruitInfoName = this.campusPickerData[0].text
          }
        }
      }).catch(e => console.log(e))
    }
  }
}
</script>
<style scoped lang="scss">
@import '../../../../assets/scss/global/variable';
@import '../../../../assets/scss/global/mixin';
.create-thing-container {
  padding-left: 20px;
  padding-right: 20px;
  @include mobile-container(64px, 74px);
  ::v-deep .mobile-nav {
    border-bottom: none;
  }
  .create-form-content {
    .form-item {
      position: relative;
      margin-bottom: 24px;
      .title-content {
        margin-bottom: 12px;
        .title {
          color: #212121;
          margin-right: 6px;
          font-weight: 500;
        }
        .title-important {
          color: $color-theme;
          font-weight: 500;
        }
      }
      .form-text {
        position: relative;
        border: 1px solid #ececec;
        border-radius: 8px;
        height: 40px;
        width: 100%;
        color: $color-title;
        padding-left: 18px;
        &::placeholder {
          color: #bcbcbc;
        }
        &:disabled {
          background-color: #f9f9f9;
          color: #9c9c9c;
          opacity: 1;
          -webkit-text-fill-color: #9c9c9c;
          border-color: #ececec;
        }
        i {
          position: absolute;
          right: 18px;
          top: 50%;
          transform: translateY(-50%);
          color: #9c9c9c;
          font-size: 14px;
        }
      }
      .textarea-content {
        width: calc(100vw - 76px);
        border: 1px solid #ececec;
        padding: 10px 18px;
        border-radius: 8px;
        resize: none;
        outline: none;
        color: $color-title;
        -webkit-appearance: none;
        appearance: none;
        font-size: $font-size-medium;
        &::placeholder {
          color: #bcbcbc;
          font-size: $font-size-medium;
        }
      }
      .date-input {
        padding-left: 18px;
        @extend .form-text;
        flex: 3;
      }
      .divider {
        width: 12px;
        height: 1px;
        background-color: #ececec;
        margin: 0 12px;
      }
      .time-input {
        padding-left: 18px;
        @extend .form-text;
        flex: 2;
      }
      .empty-value {
        color: #BCBCBC;
      }
      .search-result-content {
        width: 100%;
        position: absolute;
        z-index: 103;
        height: calc(calc(var(--vh, 1vh) * 100) - 138px);
        top: 72px;
        background-color: $color-light;
        // border: 1px solid #eeeff0;
        // border-radius: 6px;
        .company-item {
          padding: 14px 18px;
          color: $color-title;
          &:first-child {
            margin-top: 10px;
          }
          &:last-child {
            margin-bottom: 10px;
          }
          .is-apply {
            width: 48px;
            height: 22px;
            background-color: #FFF6F4;
            border-radius: 4px;
            color: $color-theme;
            font-size: $font-size-small;
          }
        }
        ::v-deep .es-highlighter {
          color: $color-theme;
        }
      }
      .form-text-diabled {
        background-color: #f9f9f9;
        color: #9c9c9c;
        border-color: #ececec;
      }
    }
  }
  .create-btn-content {
    position: fixed;
    bottom: 0;
    width: calc(100vw - 40px);
    background-color: $color-light;
    @include fixed-bottom(29px);
    .create-btn {
      width: 100%;
      height: 44px;
      border-radius: 22px;
      font-size: $font-size-medium-x;
      font-weight: 500;
    }
    .btn-disabled {
      background-color: #cfcfcf;
    }
    .delete-btn {
      width: 122px;
      margin-right: 12px;
      height: 44px;
      border-radius: 22px;
      font-size: $font-size-medium-x;
      font-weight: 500;
      i {
        margin-right: 4px;
        font-size: 18px;
      }
    }
  }
  .search-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 101;
    background-color: transparent;
  }
}
</style>